module.exports = __webpack_public_path__ + "static/Especial_ilus_02-507c1a44b1ec3f9234acdffe25ed5147.png";